import { useState } from 'react'
import { dateTimeStampFormat, numberFormat } from 'shared/util'
import {
  Box,
  Button,
  Divider,
  Stack,
  StackProps,
  Typography
} from '@mui/material'
import { Section } from 'components/controls/section'
import { ValueSpan } from 'components/controls/valueSpan'

import { SearchResult } from 'interface/search'
import { EvaluationUploadDialog } from './dialog/evaluationUploadDialog'

type SearchImportPageProps = {
  search: SearchResult
} & StackProps
export const SearchImportPage = ({
  search,
  ...others
}: SearchImportPageProps) => {
  const [modal, setModal] = useState<'evaluation' | null>(null)
  const [evaluationResult, setEvaluationResult] = useState<{
    recordCount: number
    kojinCount: number
    uploadTime: string | null
  }>({
    recordCount: search.evaluationRecordCount ?? 0,
    kojinCount: search.evaluationKojinCount ?? 0,
    uploadTime: search.evaluationUploadTime
  })
  return (
    <>
      <Stack {...others} direction="column" height="100%" overflow="auto">
        {search.evaluationFormId && (
          <Section label="評価データ" labelProps={{ py: 3 }}>
            <Stack direction="row" spacing={2} alignItems="center">
              <Button
                variant='contained'
                onClick={() => setModal("evaluation")}
              >
                アップロード
              </Button>

              {evaluationResult.uploadTime ? (
                <Box>
                  <Stack direction="row" alignItems="center" paddingX={2} spacing={1}>
                    <ValueSpan prefix="医師" text={`${numberFormat(evaluationResult.kojinCount)}`} suffix='人'/>
                    <ValueSpan prefix="件数" text={`${numberFormat(evaluationResult.recordCount)}`} suffix='件'/>
                  </Stack>
                  <Divider/>
                  <Stack direction="row" alignItems="center" paddingX={2} spacing={0.5}>
                    <Typography variant='body2'>{dateTimeStampFormat(evaluationResult.uploadTime)}</Typography>
                    <Typography variant='body2' color="textSecondary">更新</Typography>
                  </Stack>
                </Box>
              ) : <></>}
            </Stack>
          </Section>
        )}

        <Section flexGrow={1}/>
      </Stack>

      {modal === "evaluation" ? (
        <EvaluationUploadDialog
          search={search}
          onSubmit={(result) => {
            setEvaluationResult(result)
            setModal(null)
          }}
          onClose={() => setModal(null)}
        />
      ) : <></>}
    </>
  )
}
